import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { createIntroducers } from "../../../apis/brokersApis";
import { useParams, useNavigate } from "react-router-dom";
import "./../../../assets/css/popup.css";
import { brokerValidationSchema } from "../../../Validations/brokersValidation";


export default function AddBrokers() {
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();

  const [addBrokerInitial, setAddBrokerInitial] = useState({
    email: "",
    gmId: "",
    crmId: "",
  });

  const formik = useFormik({
    initialValues: addBrokerInitial,
    enableReinitialize: true,
    validationSchema: brokerValidationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        console.log(values);
        const res = await createIntroducers(values);
        setMessage(res.result.message);
        formik.resetForm();
        navigate("/brokers");
      } catch (error) {
        console.error("Error submitting form:", error);
        setMessage("Error submitting form");
      } finally {
        setLoading(false);
      }
    },
  });

  const backClick = () => {
    navigate("/brokers");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          {!editLoading && (
            <div className="content container-fluid">
              <i
                className="fas fa-arrow-left"
                style={{ marginRight: "30px", fontSize: "20px" }}
                onClick={backClick}
              />
              <div className="my-3 p-3 bg-body rounded shadow-sm">
                <h3>Add Introducer</h3>
                {editLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "50px", padding: "7px 30px" }}
                  >
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.email && formik.touched.email && (
                        <span className="text-danger">{formik.errors.email}</span>
                      )}
                    </div>
                    <div className="input-block mb-3">
                      <label className="col-form-label">GmId</label>
                      <input
                        className="form-control"
                        type="text"
                        name="gmId"
                        value={formik.values.gmId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.gmId && formik.touched.gmId && (
                        <span className="text-danger">{formik.errors.gmId}</span>
                      )}
                    </div>
                    <div className="input-block mb-3">
                      <label className="col-form-label">CrmId</label>
                      <input
                        className="form-control"
                        type="text"
                        name="crmId"
                        value={formik.values.crmId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.crmId && formik.touched.crmId && (
                        <span className="text-danger">{formik.errors.crmId}</span>
                      )}
                    </div>
                    {loading ? (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "50px", padding: "7px 30px" }}
                      >
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <button className="btn btn-primary" type="submit">
                        {id ? "Update" : "Submit"}
                      </button>
                    )}
                  </form>
                )}
                {message && <div className="mt-3 alert alert-info">{message}</div>}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
